import { connect } from "react-redux";
import {
    Box,
    Table,
    Text,
    VStack,
} from '@chakra-ui/react';
import OrganizationTicketsOutcomeChart from "../charts/OrganizationTicketsOutcomeChart";
import ConfiguredReportTable from "../../reports/ConfiguredReportTable";
import { TICKET_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

import { formatNumber } from '../../../store/helpers';

export const renderTicketSummaryCell = (row, columnId) => {
  if (columnId === "scopeName") return row.scopeName || row.name;
  if (columnId === "total") return formatNumber(row.total);
  if (columnId === "average") return formatNumber(row.average ?? row.averageTicketsPerDay);
  if (columnId === "min") return formatNumber(row.min ?? row.minTicketsPerDay);
  if (columnId === "max") return formatNumber(row.max ?? row.maxTicketsPerDay);
  if (columnId === "completed") return formatNumber(row.completed ?? row.totalCompleted);
  if (columnId === "noShow") return formatNumber(row.noShow ?? row.totalNoShow);
  if (columnId === "unattended") return formatNumber(row.unattended ?? row.totalUnattended);
  return null;
};

const AllTicketsTable = ({
  table,
  chart,
  reportIndex,
  renderConfig,
}) => { 
  if (!renderConfig?.charts?.enabled) {
    return (
      <Box mt={10} className="ticketSummaryBlock">
        <ConfiguredReportTable
          columns={TICKET_SUMMARY_COLUMN_DEFINITIONS}
          rows={table.map((row) => ({ ...row, scopeName: row.name || "Entire Organization" }))}
          renderConfig={renderConfig}
          renderCell={renderTicketSummaryCell}
        />
      </Box>
    );
  }

  return (
    <Box mt={10}>
      
      <Box>
        {
          table.map( (a, index) => 
            <Box className="reportContainer" key={index}>
            <Box mb="10px">
              <h3>{reportIndex}. {index+1}. {a.name}</h3>
            </Box>
            <Table.Root key={index} className="stripedTable" size="sm">
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
                  <Table.ColumnHeader>Avg /day.</Table.ColumnHeader>
                  <Table.ColumnHeader>Min.</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Max</Table.ColumnHeader>
                  <Table.ColumnHeader>Completed</Table.ColumnHeader>
                  <Table.ColumnHeader>No Show</Table.ColumnHeader>
                  <Table.ColumnHeader>Unattended</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>

                <Table.Row >
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text color={'var(--blue)'}>{formatNumber(a.total)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatNumber(a.averageTicketsPerDay)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatNumber(a.minTicketsPerDay)}</Text>
                  </Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text>{formatNumber(a.maxTicketsPerDay)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                  <VStack p={0} m={0} gap={0}>
                      <Text color={'var(--green)'}>
                        {formatNumber(a.completed)}
                      </Text>
                      <Text color='gray.500' fontWeight='semibold' fontSize='xs' textTransform='uppercase'>({a.pctCompleted.toFixed(2)}%)</Text>
                    </VStack>
                  </Table.Cell>
                  <Table.Cell>
                  <VStack p={0} m={0} gap={0}>
                      <Text cursor="pointer" color={'var(--red)'}>
                        {formatNumber(a.noShow)}
                      </Text>
                      <Text color='gray.500' fontWeight='semibold' fontSize='xs' textTransform='uppercase'>({a.pctNoShow.toFixed(2)}%)</Text>
                    </VStack>
                  </Table.Cell>
                  <Table.Cell>
                  <VStack p={0} m={0} gap={0}>
                      <Text color={'var(--red)'}>
                        {formatNumber(a.unattended)}
                      </Text>
                      <Text color='gray.500' fontWeight='semibold' fontSize='xs' textTransform='uppercase'>({a.pctUnattended.toFixed(2)}%)</Text>
                    </VStack>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>

            </Table.Root>
            <Box className="ticketOutcomeChartBlock">
              <OrganizationTicketsOutcomeChart
                title="Entire Organization Ticket Outcomes, Day by Day"
                chart={chart}
                chartHeight="320px"
              />
            </Box>
          </Box>
          )
        }
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
    const { defaultReducer } = state
    return {
      tickets: defaultReducer.tickets,
    };
};
export default connect(mapStateToProps, {})(
    AllTicketsTable
);
